/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Track } from 'twilio-video';
import { VideoTrack } from '../../VideoTrack/VideoTrack';
import { useTrack } from '../../../../hooks/videoProvider/useTrack';
import { AudioTrack } from '@components/videoProvider/twilio/AudioTrack/AudioTrack';
import { includes } from '@utils/lodash';

export namespace Publication {
  export interface Props {
    publication?: VideoProvider.ITwilioPublication;
    participant: VideoProvider.IParticipant;
    isLocal: boolean;
    isDominantSpeaker?: boolean;
    videoPriority?: Track.Priority | null;
  }
}

export const Publication: React.FunctionComponent<Publication.Props> = ({
  publication,
  isLocal,
  videoPriority,
  isDominantSpeaker,
}) => {
  // TODO: (ZOOMSDK) - fix the typing of track for Zoom
  const track = useTrack(publication);

  if (!track) {
    return null;
  }
  switch (track.kind) {
    case 'video':
      return (
        <VideoTrack
          track={track}
          priority={videoPriority}
          isLocal={includes(track.name, 'camera') && isLocal}
          isDominantSpeaker={isDominantSpeaker}
        />
      );
    case 'audio':
      return <AudioTrack track={track} />;
    default:
      return null;
  }
};
